export default "__VITE_ASSET__6XpHx5pe__"